var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDashboard18 = function SvgAIconDashboard18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 5.59999,
    height: 5.59999,
    rx: 1,
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10.4,
    width: 5.59999,
    height: 5.59999,
    rx: 1,
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4014,
    y: 2,
    width: 5.59999,
    height: 5.59999,
    rx: 1,
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4014,
    y: 10.4,
    width: 5.59999,
    height: 5.59999,
    rx: 1,
    strokeWidth: 1.5
  })));
};
export { SvgAIconDashboard18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjIiIHk9IjIiIHdpZHRoPSI1LjU5OTk5IiBoZWlnaHQ9IjUuNTk5OTkiIHJ4PSIxIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cmVjdCB4PSIyIiB5PSIxMC40IiB3aWR0aD0iNS41OTk5OSIgaGVpZ2h0PSI1LjU5OTk5IiByeD0iMSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHJlY3QgeD0iMTAuNDAxNCIgeT0iMiIgd2lkdGg9IjUuNTk5OTkiIGhlaWdodD0iNS41OTk5OSIgcng9IjEiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxyZWN0IHg9IjEwLjQwMTQiIHk9IjEwLjQiIHdpZHRoPSI1LjU5OTk5IiBoZWlnaHQ9IjUuNTk5OTkiIHJ4PSIxIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K";